import React from 'react';
import { connect } from 'react-redux';
import ObservateursDialog from './ObservateursDialog';
import { closeObservateursDialog } from 'store/common/commonActions';
import { fetchReclamationObservateurs, addReclamationObservateur, removeReclamationObservateur } from 'store/reclamation/detailsActions';
import { clearUtilisateurValue } from '../../../store/utilisateur/utilisateursActions';

const Namespace = 'observateurReclamation';

class ObservateursDialogContainer extends React.Component {
    
    componentDidMount() {
        this.initState();
    }

    componentDidUpdate(prevProps) {
        if (this.props.reclamation.id && !prevProps.open && this.props.open)
            this.props.fetchReclamationObservateurs(this.props.reclamation.id);
    }

    initState() {
        this.setState({
            utilisateur: {
                id: 0,
                codePO: '',
                nom: '',
                prenom: ''
            }
        });
    }

    handleClose = () => {
        this.props.closeObservateursDialog();
    }

    handleChangeUtilisateur = (id, codePO, nom, prenom, error) => {
        this.setState({ utilisateur: { id, codePO, nom, prenom } });
    }

    handleAddObservateur = async () => {
        await this.props.addObservateur(this.props.reclamation.id, this.state.utilisateur.id);
        this.props.fetchReclamationObservateurs(this.props.reclamation.id);
        this.initState();
        this.props.clearUtilisateurValue();
    }

    handleDeleteObservateur = (id) => {
        this.props.removeObservateur(this.props.reclamation.id, id);
    }

    render() {
        const utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));
        
        // Vérifier si l'utilisateur est affecté au dossier
        let isUtilisateurAffecte =
            this.props.reclamation.affectationUtilisateur !== undefined &&
            this.props.reclamation.affectationUtilisateur !== null &&
            this.props.reclamation.affectationUtilisateur.id === utilisateurCourant.id;

        // Vérifier si l'utilisateur est pilote ou admin du groupe affecté
        let isPiloteOuAdminGroupe = false;
        if (this.props.reclamation.affectationGroupe && utilisateurCourant.groupes) {
            const groupeAffecte = utilisateurCourant.groupes.find(g => g.id === this.props.reclamation.affectationGroupe.id);
            if (groupeAffecte) {
                isPiloteOuAdminGroupe = groupeAffecte.adminOuPilote;
            }
        }

        // Edition autorisée si utilisateur affecté OU pilote/admin du groupe
        let editionAutorisee = isUtilisateurAffecte || isPiloteOuAdminGroupe;

        return (
            <ObservateursDialog
                open={this.props.open}
                onClose={this.handleClose}
                observateurs={this.props.observateurs}
                isLoading={this.props.isLoading}
                editionAutorisee={editionAutorisee}
                onChangeUtilisateur={this.handleChangeUtilisateur}
                onAddObservateur={this.handleAddObservateur}
                onDeleteObservateur={this.handleDeleteObservateur}
                namespace={Namespace}
            />);
    }
}

const mapStateToProps = state => ({
    open: state.common.observateursDialogOpen,
    observateurs: state.reclamation.details.item.observateurs,
    reclamation: state.reclamation.details.item,
    isLoading: state.reclamation.details.isObservateursLoading
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationObservateurs: id => dispatch(fetchReclamationObservateurs(id)),
    closeObservateursDialog: () => dispatch(closeObservateursDialog()),
    addObservateur: (reclamationId, utilisateurId) => dispatch(addReclamationObservateur(reclamationId, utilisateurId)),
    removeObservateur: (reclamationId, utilisateurId) => dispatch(removeReclamationObservateur(reclamationId, utilisateurId)),
    clearUtilisateurValue: () => dispatch(clearUtilisateurValue())
});

export default connect(mapStateToProps, mapDispatchToProps)(ObservateursDialogContainer);